import { useEffect, useState } from "react";
import { NAV_ITEMS } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 right-0 left-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-background-200/80 bg-background-50/90 backdrop-blur-md" : "bg-background-50"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#hero" className="flex shrink-0 items-center gap-2.5" aria-label="本月大瓜首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="font-heading text-xl font-black tracking-wide text-foreground-950 md:text-2xl">
            本月大瓜
          </span>
          <span className="mt-1 hidden rounded-full border border-accent-400 bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-800 sm:inline-block">
            实时热榜中
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主栏目">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-secondary-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#focus"
            className="hidden whitespace-nowrap items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            一起围观
            <i className="ri-arrow-right-up-line" />
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-800 hover:bg-secondary-100 lg:hidden"
            aria-label="展开菜单"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="animate-fade-up border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden"
          aria-label="移动端栏目"
        >
          <div className="grid gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#focus"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-lg bg-primary-500 px-3 py-2.5 text-sm font-semibold text-background-50"
            >
              一起围观
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}